import(/* webpackMode: "eager" */ "/opt/render/project/src/refgd/app/community/tg-webapp.css");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/refgd/app/community/telegram.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/community/tg/TelegramApp.tsx");
